export default {
  name: "Add Ad Hoc Document(s)",
  pageInfo: {
    text: "Use this form to upload an additional document to your submitted application. Uploaded documents will be added to the case documents and directed to an analyst for review. Please do NOT use this form to upload a response to a Notice of Deficiency (NOD) or to upload a Recruitment Report.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "fileType",
          widget: "text",
          value: "Ad Hoc",
          style: {
            display: "none",
          },
        },
        {
          machine_name: "files",
          widget: "file_upload",
          file_upload: { fileType: "Ad_Hoc_Document_Upload" },
          accept_multiple: false,
          required: true,
          validate: ["required", "file_required"],
          checkFilesAdded: true,
          documentAuth: "dh",
        },
        {
          machine_name: "document_description",
          widget: "text",
          label: "Document Description",
          validate: ["required"],
          maxLength: 100,
        },
      ],
    },
  ],
};
